import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CalendarModule } from "primeng/calendar";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconsModule } from "@mk/med-icons";

import { MedDatepickerComponent } from "./med-datepicker.component";
import { MedLabelModule } from "../med-label/med-label.module";

@NgModule({
  declarations: [
    MedDatepickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedIconsModule,
    MedLabelModule,
    CalendarModule,
  ],
  exports: [
    MedDatepickerComponent,
  ],
})
export class MedDatepickerModule { }
